import axios from './axios';

export const fetchClientConfig = async () => {
    const response = await axios.get('/config');
    return response.data;
};
